import { parseSearch } from "@faire/next-utils/lib/parseSearch";
import { isPDPRoute } from "@faire/retailer-visitor-shared/nextjs-rsc-util/isPDPRoute";

// Only request RSC payload on showSideCart change
export const getShouldRequestRSCOnPDP = (options: {
  prevSearch: string;
  pathname: string;
  search: string;
}): boolean => {
  const { prevSearch, pathname, search } = options;

  return (
    isPDPRoute(pathname, search) !== null &&
    didShowSideCartChange(prevSearch, search)
  );
};

const didShowSideCartChange = (prevSearch: string, search: string): boolean => {
  const parsedSearch = parseSearch({ search });
  const parsedPrevSearch = parseSearch({ search: prevSearch });
  return parsedSearch.showSideCart !== parsedPrevSearch.showSideCart;
};
